import { Chip, SxProps, Theme } from '@mui/material'
import React from 'react'
import { colors } from '../../theme'

interface Props {
  sx?: SxProps<Theme>
}

export const GuestAdoptionChip: React.FC<Props> = ({ sx }) => (
  <Chip
    label="Adoption en ligne (invité)"
    size="small"
    sx={{ backgroundColor: colors.mintTulip, color: colors.cello, fontWeight: 700, ...sx }}
  />
)
